import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M16.105 11.447L17.381 14h-8.38v-2h4a1 1 0 0 0 1-1V8h3.38l-1.276 2.552a1 1 0 0 0 0 .895zM2.691 4h9.31v6H4.026L2.692 4zm15.428 7l1.776-3.553A.998.998 0 0 0 19 6h-5V3a1 1 0 0 0-1-1H2.248L1.976.782A1.005 1.005 0 0 0 .783.022c-.539.12-.879.654-.76 1.194l4 18a1.002 1.002 0 0 0 1.194.76c.538-.12.879-.654.76-1.194L4.468 12H7v3a1 1 0 0 0 1 1h11a1 1 0 0 0 .895-1.447L18.119 11z"
});

var SvgFlagMajorMonotone = function SvgFlagMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref);
};

export { SvgFlagMajorMonotone as S };
